import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useLang } from "../contexts/LanguageContext";
import { CalendarDays, MapPin } from "lucide-react";

export default function Events() {
  const { t, pick, lang } = useLang();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  const fmt = (iso) => new Date(iso).toLocaleDateString(lang === "hu" ? "hu-HU" : "en-GB", {
    year: "numeric", month: "long", day: "numeric",
  });

  return (
    <div className="py-20 md:py-28 container-deg" data-testid="events-page">
      <div className="max-w-2xl mb-12">
        <div className="overline">06 · {t("nav.events")}</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-4 text-balance">{t("events.heading")}</h1>
        <p className="text-ink-soft mt-6 leading-relaxed">{t("events.sub")}</p>
      </div>

      {events.length === 0 ? (
        <p className="text-ink-soft py-20 text-center">{t("events.no_events")}</p>
      ) : (
        <div className="space-y-6">
          {events.map((ev, i) => (
            <article key={ev.id} className="card-deg grid grid-cols-1 md:grid-cols-12" data-testid={`event-${i}`}>
              <div className="md:col-span-4 aspect-[4/3] md:aspect-auto bg-bg-muted overflow-hidden">
                {ev.image_base64 ? (
                  <img src={ev.image_base64} alt={pick(ev, "title")} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-secondary">
                    <CalendarDays size={56} strokeWidth={1} />
                  </div>
                )}
              </div>
              <div className="md:col-span-8 p-8">
                <div className="overline">{fmt(ev.start_date)}{ev.end_date ? ` — ${fmt(ev.end_date)}` : ""}</div>
                <h2 className="font-serif text-3xl md:text-4xl mt-3">{pick(ev, "title")}</h2>
                <div className="flex items-center gap-2 text-sm text-secondary mt-3">
                  <MapPin size={14} strokeWidth={1.5} /> {pick(ev, "location") || "—"}
                </div>
                <p className="text-ink-soft mt-5 leading-relaxed">{pick(ev, "description")}</p>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
